export default {
  "manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["评估管理"])},
  "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部"])},
  "attended": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已参加"])},
  "absent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["缺席"])},
  "upload_complete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上传完成"])},
  "upload_incomplete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上传未完成"])},
  "examNumber_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按考试号或姓名搜索"])},
  "view_QR": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看二维码"])},
  "view_QR_tip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果您扫描考试室张贴的二维码，您将能够开始世宗韩国语评估（SKA）口语考试。"])},
  "print": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印"])},
  "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
}